import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=3e519b9e&"
import script from "./Objects.vue?vue&type=script&lang=js&"
export * from "./Objects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports